import {interopDefault} from '@/utils/helpers'
const SupplierInvoicesPage = () => interopDefault(import('@@/mods/zsh/pages/SupplierInvoicesPage.vue'))
const ReservationStatementPage = () => interopDefault(import('@@/mods/zsh/pages/ReservationStatementPage.vue'))

export default [
    {
        path: '/reservation-statements',
        component: SupplierInvoicesPage,
        name: 'reservationStatements',
        meta: {
            middleware: 'auth',
        },
    },
    {
        path: '/reservation-statement/:reservationNumber',
        component: ReservationStatementPage,
        name: 'reservationStatement',
        meta: {
            middleware: 'auth',
        },
    },
]
